module.exports = __webpack_public_path__ + "media/images/competitions/calendar-3a0ef62a2160799843c533f3804ff187.png";